import { NEARBY_WS_PATH } from "../nearbyTransfer.constants";

export const buildNearbyWebSocketUrl = ({ apiBaseUrl, configuredUrl } = {}) => {
  if (configuredUrl) return configuredUrl;

  const apiUrl = new URL(apiBaseUrl);
  apiUrl.protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
  apiUrl.pathname = NEARBY_WS_PATH;
  apiUrl.search = "";
  apiUrl.hash = "";
  return apiUrl.toString();
};
